import { getOverviewMentionsSentiment } from '@/pages/opinion/services';
import {
  addRateValue,
  addWithoutSingleData,
  arrayToSimpleObj,
  retainDecimals,
} from '@/pages/opinion/utils';
import { useState } from 'react';

type MentionsSentimentType = {
  timeline_of_end_time: string;
  timeline_of_start_time: string;
  list: Array<any>;
};

export function useMentionsSentimentData() {
  const dealwithSentiment = (
    mentionsSentiment: MentionsSentimentType,
    filter: { date_type: string },
  ) => {
    if (mentionsSentiment) {
      let { timeline_of_end_time, timeline_of_start_time, list } =
        mentionsSentiment || {};

      list = addWithoutSingleData(
        timeline_of_start_time,
        timeline_of_end_time,
        filter.date_type,
        list,
        {
          avg_sentiment: 0,
          mention: 0,
          brand_health: 0,
          negative_mention: 0,
          neutral_mention: 0,
          positive_mention: 0,
        },
      );

      let dataList = addRateValue(
        list || [],
        ['negative_mention', 'neutral_mention', 'positive_mention'],
        'mention',
        (item: any) => ({ sentiment_avg: retainDecimals(item.avg_sentiment) }),
      );
      return dataList;
    }

    return [];
  };

  const [dataList, setDataList] = useState<Array<any>>([]);
  const [loading, setLoading] = useState(false);

  const getOverviewMentionsSentimentServerData = (params: any) => {
    setLoading(true);
    getOverviewMentionsSentiment({ ...params, need_brand_health: true })
      .then((data: any) => {
        const dataList = dealwithSentiment(data, params);

        setDataList(dataList);
      })
      .catch(() => {
        setDataList([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return { getOverviewMentionsSentimentServerData, dataList, loading };
}
